import axiosInstance from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const createDepartmentApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/department`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateDepartmentApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      BASE_URL + `v1/${STAGE}/dashboard/department/${payload._id}`,
      { name: payload.name }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDepartmentApi = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/department`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
